import { render, staticRenderFns } from "./UserFullName.vue?vue&type=template&id=757a1c06"
import script from "./UserFullName.vue?vue&type=script&lang=js"
export * from "./UserFullName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports